import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "../../../constants/Icons";

const ConfirmResetAccount = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email || "";

  const inputRef = useRef(null);

  const [resetText, setResetText] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setResetText(e.target.value);
    setError("");
  };

  const handleContinue = () => {
    setError("");

    if (resetText.trim() !== "RESET") {
      setError("Please type RESET to confirm.");
      inputRef.current?.focus();
      return;
    }

    navigate("/reset-account", {
      replace: true,
      state: {
        email,
      },
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleContinue();
    }
  };

  const handleBack = () => {
    navigate("/profile", {
      replace: true,
    });
  };

  return (
    <div className="wrapper">
      <div className="authentication-reset-password d-flex align-items-center justify-content-center">
        <div className="container">
          <div className="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
            <div className="col mx-auto">
              <div className="card">
                <div className="card-body">
                  <div className="p-4">
                    <div className="mb-4 text-center">
                      <img
                        src="assets/images/logo-icon.png"
                        width="60"
                        alt=""
                      />
                    </div>

                    <div className="text-start mb-4">
                      <h4 className="mt-3 fw-400">Confirm Account Reset</h4>

                      <p className="mb-0">
                        You are about to permanently reset your account.
                      </p>

                      <p className="mb-0">This action cannot be reversed.</p>

                      {email && (
                        <p className="mt-2 mb-0">
                          Account: <strong>{email}</strong>
                        </p>
                      )}
                    </div>

                    <div className="row g-3">
                      <div className="col-12">
                        <label htmlFor="resetText" className="form-label">
                          Type RESET
                          <span className="text-danger"> *</span>
                        </label>

                        <input
                          ref={inputRef}
                          type="text"
                          id="resetText"
                          name="resetText"
                          className={`form-control ${
                            error ? "is-invalid" : ""
                          }`}
                          autoComplete="off"
                          value={resetText}
                          onChange={handleChange}
                          onKeyDown={handleKeyDown}
                        />

                        {error && (
                          <div className="invalid-feedback d-block">
                            {error}
                          </div>
                        )}
                      </div>

                      <div className="col-12">
                        <div className="d-grid">
                          <button
                            type="button"
                            onClick={handleContinue}
                            className={
                              resetText.trim() === "RESET"
                                ? "btn btn-danger"
                                : "btn btn-secondary"
                            }
                            disabled={resetText.trim() !== "RESET"}
                          >
                            Continue
                          </button>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="text-center">
                          <button
                            type="button"
                            onClick={handleBack}
                            className="btn btn-link text-decoration-none shadow-none"
                          >
                            <ChevronLeftIcon iClass={"me-1 fs-18"}/>
                            Back
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmResetAccount;
